<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ title }}</p>
        </header>
        <section class="modal-card-body" >
            <o-field label="Estimated Bill Date">
                <datepicker :config="config" v-model="date" :absolute="true" :required="true" :class="projectServiceById(service.id).estimated_bill_date ? 'is danger' : ''" />
            </o-field>

          <div v-if="projectServiceById(service.id).estimated_bill_date">
            <div class="warning-msg">
              <i class="fa fa-warning"></i>
              Please be aware if you change dates, your accuracy will be affected. 1
            </div>
          </div>

<!--          <div v-if="isEstimatedDateNull(service.id)">-->
<!--            <div class="warning-msg">-->
<!--              <i class="fa fa-warning"></i>-->
<!--              Please be aware if you change dates, your accuracy will be affected. 2-->
<!--            </div>-->
<!--          </div>-->


            <o-field label="Notes" :type="fieldType('notes')" :message="getError('notes')" v-bind:class="{ 'is-danger': !areNotesValid }">
                <o-input type="textarea" v-model="notes" />
            </o-field>
            <div v-if="Array.isArray(notesHistory) && notesHistory.length">
                <label class="label">
                    <a href="#" @click.prevent="openNotesHistoryModal()">Notes history</a>
                </label>
            </div>
           <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isNotesHistoryModalActive" has-modal-card>
                <notes-history-modal :projectService="service"/>
            </o-modal>
        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
            <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary" v-bind:class="{ 'btn-disabled': !isValid}">Save</button>
        </footer>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Datepicker from './../Datepicker'
    import HandlesForm from './../../mixins/HandlesForm'
    import NotesHistoryModal from './NotesHistoryModal'

    const now = new Date(new Date().toLocaleDateString());

    export default {
        props: ['serviceinfo', 'notesHistory'],

        mixins: [HandlesForm],

        components: {
            Datepicker,
            NotesHistoryModal,
        },

        computed: {
            ...mapGetters(["projectServiceById"]),
            title() {
                return this.isManyServices ? 'Various services' : this.service.title
            },
            isManyServices() {
                return Array.isArray(this.serviceinfo)
            },
            service() {
                if(this.isManyServices) {
                    return this.serviceinfo[0]
                } else {
                    return this.serviceinfo
                }
            },
            isValid() {
                return this.areNotesValid && this.date
            },
            
            areNotesValid() {
                var ebd = `${this.service.estimated_bill_date} `
                var d = this.date
                return (
                    (!d && ebd && !(new Date(ebd) < now)) ||
                    (d && !(new Date(d) < now) && ebd && !(new Date(ebd) < now) ) ||
                    (!ebd && d && !(new Date(d) < now) ) ||
                    (!!this.notes && this.notes.length > 0) ||
                    ( !d && !ebd)
                )
            }
        },
        
        data() {
            return {
                config: {
                    minDate: 'today'
                },
                date: null,
                isNotesHistoryModalActive: false,
                notes: '',
                restriction: {
                  user_id: null,
                  project_id: null,
                  previous_date: null,
                  current_date: null,
                }
            }
        },

        mounted() {
            this.date = this.service.estimated_bill_date
            this.notes = this.isValid ? this.service.notes : '';
            // console.log(this.projectServiceById("36057").estimated_bill_date, this.projectServiceById("36057").id)
        },

        methods: {
            ...mapActions(['updateProjectService', 'restrictionApplied', 'fetchCurrentUser']),

            isEstimatedDateNull(id){
              !!this.projectServiceById(id).estimated_bill_date
            },

            handleSubmit() {
                if(!this.isValid) return;
                let submit = this.wrapSubmit(this.updateProjectService)
                
                if(this.isManyServices) {
                    this.serviceinfo.forEach(s => {
                        submit({
                            id: s.id,
                            notes: this.notes,
                            estimated_bill_date: this.date
                        }).then(r => {
                            this.successMessage('Estimated bill date has been updated successfull')
                            this.$parent.$parent.$emit('update:active', false)
                            this.$emit('onSaved')
                            return r
                        })
                    })
                } else {
                    submit({
                        id: this.service.id,
                        notes: this.notes,
                        estimated_bill_date: this.date
                    }).then(r => {
                        this.successMessage('Estimated bill date has been updated successfull')
                        this.$parent.$parent.$emit('update:active', false)
                        this.$emit('onSaved')
                        return r
                    })
                }

              if (this.projectServiceById(this.service.id).estimated_bill_date){
                this.restrictionApplied({
                  // user_id: this.service.assigned_to,
                  service_id: this.service.id,
                  previous_date: this.service.estimated_bill_date,
                  current_date: this.date,
                })
              }
            },
            openNotesHistoryModal() {
                this.isNotesHistoryModalActive = true
            },
        }
    }
</script>

<style scoped>
.info-msg,
.success-msg,
.warning-msg,
.error-msg {
  margin: 10px 0;
  padding: 10px;
  border-radius: 3px 3px 3px 3px;
}
.warning-msg {
  color: #9F6000;
  background-color: #FEEFB3;
}
</style>
